import { Navigate } from 'react-router-dom';
import { useAuth, STORAGE_TOKEN_KEY } from '../contexts/AuthContext';
import { motion } from 'framer-motion';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const hasToken = !!localStorage.getItem(STORAGE_TOKEN_KEY);

  // Show loading state when:
  // 1. Auth context reports loading
  // 2. We have a token but no user yet (still loading)
  if (loading || (hasToken && !user)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#699269]"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Only redirect if we have no token AND no user
  if (!user && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

